import { CrashTrenballColor } from '@/models/crash/trenball/color';

export const trenballColors = new Map<CrashTrenballColor, string>([
  [CrashTrenballColor.Orange, '#EC6300'],
  [CrashTrenballColor.Green, '#3BC016'],
  [CrashTrenballColor.Yellow, '#E2B40C'],
]);
